module.exports = __webpack_public_path__ + "img/nutrition-classes.aceb5704.jpg";